module.exports = __webpack_public_path__ + "img/dd.361ec8bd.png";